<template>
<div id="dlXlsx">
    <!-- <el-button type="primary" @click="setXlsx(sheet, head, data)">下载数据</el-button> -->
    <span class="downEx" style="cursor: pointer;" @click="setXlsx(sheet, head, data)">导出表格</span>
</div>
</template>

<script>
import xlsx from "@/common/xlsx"
import _ from 'lodash'
var that = null;
export default {
    props: {
        sheet: {
            type: Array
        },
        head: {
            type: Array
        },
        data: {
            type: Array
        }
    },
    data() {
        that = this;
        return {};
    },
    methods: {
        setXlsx(sheet, head, data) {
            var Sheets = [],
                List = [],
                Heads = [],
                li = []; // sheets工作簿 名称，list数据 对象数组，heads 头部标题
            Sheets.push(sheet)
            Heads.push(head)

            _.forEach(data, function (v) {
                var obj = new Object();
                obj = v
                li.push(obj)
            })
            List.push(li)

            var ExeclConfig = {
                SheetName: sheet,
                data: {
                    Head: Heads, // 头部标题 如只有一个 就全一样
                    Sheets: Sheets, //工作薄 名称
                    List: List, //数据 对象数组
                }
            }
            console.log(ExeclConfig)
            // return
            xlsx.toExecl(ExeclConfig)
        }
    }
}
</script>

<style>
</style>
